import React, { Component } from 'react';
import { Modal, Header, Form, Button, Tab, Message } from 'semantic-ui-react';
import PartTable from './PartTable';
import LabourTable from './LabourTable';
import OtherCostTable from './OtherCostTable';
import { observer, inject } from 'mobx-react';
import Estimate from '../../models/Estimate';
import EstimateForm from './EstimateForm';
import EstimateView from './EstimateView';
import { getSnapshot } from 'mobx-state-tree';
import CustomerSelector from '../customers/CustomerSelector';
import Job from '../../models/Job'
import shortid from 'shortid';

class JobForm extends Component {
  
  state = {
    isCustomerSelectorOpen: false,
    isNewEstimateFormOpen: false,
    newEstimateModel: null
  }

  initialSnapshot = null

  openNewEstimateForm = () => {
    this.setState({ 
      newEstimateModel: Estimate.create(),
      isNewEstimateFormOpen: true,
    })
  }

  closeNewEstimateForm = () => this.setState({ isNewEstimateFormOpen: false })

  render() { 
    if (!this.props.model) return null
    const { model } = this.props
    const { usualCustomer, jobNumber, description, finish, comment } = model
    const estimatePanes = model.estimates.map((e,i) => (
      { menuItem: e.qty + 'x', render: () => <EstimateView key={i} estimate={e} /> }
    ))
    return (
      <div>
        <CustomerSelector 
          isOpen={this.state.isCustomerSelectorOpen}
          onClose={this.closeCustomerSelector}
          onSelectItem={this.handleSelectCustomer}
        />
        {this.state.newEstimateModel &&
          <Modal size='small' open={this.state.isNewEstimateFormOpen}>
            <Modal.Header content='New Estimate' />
            <Modal.Content>
              <EstimateForm estimate={this.state.newEstimateModel} />
            </Modal.Content>
            <Modal.Actions>
              <Button type='button' positive disabled={!this.state.newEstimateModel.isValid} onClick={this.addEstimate}>Save</Button>
              <Button type='button' color='orange' onClick={this.closeNewEstimateForm}>Cancel</Button>
            </Modal.Actions>
          </Modal>
        }
        <Modal open={this.props.isOpen} size='large'>
          <Modal.Header content='Quote Form' />
          <Modal.Content scrolling>
            <Form as='div'>
              <Form.Field>
                <label>Usual customer</label>
                <span className='static'>
                  {usualCustomer ? <em>{usualCustomer.name}</em> : <span className='mute'>Not required but can be useful</span>}
                  &emsp;
                  <a href='#select-customer' onClick={this.openCustomerSelector}>
                    {usualCustomer ? 'Change' : 'Select customer'}
                  </a>
                </span>
              </Form.Field>
              <Form.Group>
                <Form.Input width={8} label='Description' value={description} onChange={this.handleChangeDescription} />
                <Form.Input width={5} label='Finish' value={finish} onChange={this.handleChangeFinish} />
                <Form.Input width={3} label='Product Code' value={jobNumber || ''} onChange={this.handleChangeJobNumber} />
              </Form.Group>
              <Form.Input label='Comment' placeholder='Optional notes etc' value={comment} onChange={this.handleChangeComment} />
              <Header size='small' content='Parts' />
              <PartTable parts={model.parts} onAdd={this.showPartForm} />
              <Header size='small' content='Labour' />
              <LabourTable labour={model.labour} />
              <Header size='small' content='Other Costs' />
              <OtherCostTable items={model.otherCosts} />
              <Header size='small'>Estimates&emsp;<a href='#add-estimtate' onClick={this.openNewEstimateForm}>Add a new estimate</a></Header>
              <Tab panes={estimatePanes} />
              {!model.hasEstimates &&
                <Message info icon='info' header='This product has no estimates yet' />
              }
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button basic primary disabled={!model.isValid} onClick={this.handleCopyJob}>Duplicate this quote</Button>
            <Button positive disabled={!model.isValid} onClick={this.handleSave}>Save and Close</Button>
            <Button type='button' color='orange' onClick={this.handleCancel}>Cancel</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }

  handleCopyJob = () => {
    const { model, store, replaceSelectedModel } = this.props
    const snapshot = getSnapshot(model)
    const duplicate = Job.create({ 
      ...snapshot, 
      id: shortid.generate(),
      description: 'Copy of ' + snapshot.description,
      jobNumber: null, // the new quote will need a new product code
      dateCreated: null, // new date will be added when attached to store
    })
    duplicate.setUsualCustomer(model.usualCustomer) // don't know why we need to do this separately
    store.setCollectionItemFromSnapshot('jobs', duplicate)
    replaceSelectedModel(duplicate)
    window.alert('Quote duplicated. You are now working on the new quote.')
    this.props.onSave() // I don't know if it is actually saving here
  }

  handleSave = () => {
    // if (!hasParent(this.props.model)) {
    //   this.props.store.setCollectionItemFromSnapshot('jobs', getSnapshot(this.props.model))
    // }
    // this.props.model.save()
    this.props.onSave()
    this.props.onClose()
  }

  handleCancel = () => {
    // if (this.initialSnapshot) {
    //   console.log(this.initialSnapshot)
    //   applySnapshot(this.props.model, this.initialSnapshot)
    // }
    this.props.onClose()
  }

  openCustomerSelector = () => this.setState({ isCustomerSelectorOpen: true })

  closeCustomerSelector = () => this.setState({ isCustomerSelectorOpen: false })

  handleSelectCustomer = customer => {
    this.props.model.setUsualCustomer(customer)
    this.closeCustomerSelector()
  }

  handleChangeNewEstimateQty  = event => {
    this.setState({
      newEstimateQty: event.target.value
    })
  }

  addEstimate = () => {
    // var parsedValue = parseInt(this.state.newEstimateQty, 10)
    // if (!isNaN(parsedValue)) this.props.model.addEstimate(parsedValue)
    this.props.model.addEstimate(getSnapshot(this.state.newEstimateModel))
    this.closeNewEstimateForm()
  }

  handleChangeDescription = event => {
    this.props.model.setDescription(event.target.value)
  }

  handleChangeFinish = event => {
    this.props.model.setFinish(event.target.value)
  }

  handleChangeComment = event => {
    this.props.model.setComment(event.target.value)
  }

  handleChangeJobNumber = event => {
    this.props.model.setJobNumber(event.target.value)
  }

}
 
export default inject('store')(observer(JobForm));


// WEBPACK FOOTER //
// ./src/components/jobs/JobForm.js